import React from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  CircularProgress,
  TextField,
  Pagination,
} from "@mui/material";
import {
  CloseRounded as CloseRoundedIcon
} from "@mui/icons-material";
import moment from "moment";
import agent from "../../../../agent/agent";
import VisibleContent from "../../../../components/VisibleContent";
import DateRangePicker from "../../../../components/DateRangePicker";

const initState = {
  isOpen: false,
  complexId: null,
  exhibitions: [],
  isLoading: false,
  errorMessage: "",
  filter: {
    date_daily: "",
    location: "",
    grz_ts: "",
    page: 1,
    limit: 10,
  },
  totalCount: 0,
  totalPages: 1,
}

class DialogExhibitions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...initState
    };
  }

  open = (item) => {
    const {complexId} = item;
    console.log('otherItem: ', item)
    this.setState({
      isOpen: true,
      complexId: complexId || null,
      exhibitions: [],
      isLoading: false,
      errorMessage: "",
      filter: {
        date_daily: "",
        location: "",
        grz_ts: "",
        page: 1,
        limit: 10,
      },
      totalCount: 0,
      totalPages: 1,
    });
    if (complexId) {
      (async () => {
        await this.loadExhibitions(complexId);
      })();
    }
  }
  close = () => {
    this.setState({
      ...initState
    })
  }

  loadExhibitions = async (complexId) => {
    if (!complexId) return;

    await this.setState({ isLoading: true, errorMessage: "" });

    const { filter } = this.state;
    const params = new URLSearchParams();
    params.append("contract_id", this.props.contractId);

    if (filter.date_daily) {
      params.append('date_daily', moment(filter.date_daily).format('YYYY-MM-DD'));
    }
    if (filter.location) {
      params.append('location', filter.location);
    }
    if (filter.grz_ts) {
      params.append('grz_ts', filter.grz_ts);
    }
    if (filter.page) {
      params.append('page', filter.page);
    }
    if (filter.limit) {
      params.append('limit', filter.limit);
    }

    const queryString = params.toString();
    const url = `/operator/sensors/${complexId}/daily${queryString ? `?${queryString}` : ''}`;

    try {
      const res = await agent.get(url)
        .then((res) => res)
        .catch((err) => {
          return {
            error: err?.response
          }
        });

      if (res?.error) {
        const errorMessage = res?.error?.data?.details || 'Ошибка при загрузке данных';
        await this.setState({
          isLoading: false,
          errorMessage: errorMessage,
          exhibitions: [],
        });
        return;
      }

      const exhibitions = res?.data?.data || [];
      const totalCount = Number.parseFloat(res?.headers?.['x-pagination-total-count'] || '0');
      const totalPages = Math.ceil(totalCount / (filter.limit || 10));

      await this.setState({
        isLoading: false,
        exhibitions: exhibitions,
        errorMessage: "",
        totalCount: totalCount,
        totalPages: totalPages,
      });
    } catch (error) {
      await this.setState({
        isLoading: false,
        errorMessage: 'Произошла ошибка при загрузке данных',
        exhibitions: [],
      });
    }
  }

  handleFilterChange = (field, value) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [field]: value,
        page: 1, // Сбрасываем страницу при изменении фильтра
      }
    }, () => {
      if (this.state.complexId) {
        this.loadExhibitions(this.state.complexId);
      }
    });
  }
  handleDateChange = ({ start, end }) => {
    const dateValue = start ? moment(start).format('YYYY-MM-DDTHH:mm:ss') : '';
    this.handleFilterChange('date_daily', dateValue);
  }
  handlePageChange = (event, page) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: page,
      }
    }, () => {
      if (this.state.complexId) {
        this.loadExhibitions(this.state.complexId);
      }
    });
  }

  formatDate = (date) => {
    if (!date) return 'Н/Д';
    if (typeof date === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(date)) {
      return date;
    }
    return moment(date).format('DD.MM.YYYY');
  }
  formatTime = (date) => {
    if (!date) return 'Н/Д';
    return moment(date).format('HH:mm');
  }

  render() {
    const {
      isOpen,
      exhibitions,
      isLoading,
      errorMessage,
      filter,
      totalCount,
      totalPages,
    } = this.state;

    if (!isOpen) {
      return null
    }

    const startIndex = (filter.page - 1) * filter.limit + 1;
    const endIndex = Math.min(filter.page * filter.limit, totalCount);
    const hasFilters =
      Boolean(filter.date_daily) ||
      Boolean(filter.location) ||
      Boolean(filter.grz_ts);

    return (
      <Dialog
        open={isOpen}
        fullWidth={true}
        maxWidth="lg"
        onClose={this.close}
      >
        <DialogTitle>
          <Grid container>
            <Grid item sx={{flex: 1}}>
              Выставления комплекса
            </Grid>
            <Grid item>
              <IconButton onClick={this.close}>
                <CloseRoundedIcon/>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 3, mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <DateRangePicker
                  label="дд-мм-гггг"
                  startDate={filter.date_daily}
                  single={true}
                  onChange={this.handleDateChange}
                  showTimePicker={false}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={filter.location}
                  onChange={(e) => this.handleFilterChange('location', e.target.value)}
                  size="small"
                  label="Местоположение"
                  variant="outlined"
                  className="--default-label"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={filter.grz_ts}
                  onChange={(e) => this.handleFilterChange('grz_ts', e.target.value)}
                  size="small"
                  label="Госномер оператора"
                  variant="outlined"
                  className="--default-label"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>

          <VisibleContent visible={isLoading}>
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <CircularProgress />
              <Typography sx={{ mt: 2 }} color="textSecondary">
                Загрузка данных...
              </Typography>
            </Box>
          </VisibleContent>
          <VisibleContent visible={!isLoading && !!errorMessage}>
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography color="error">
                {errorMessage}
              </Typography>
            </Box>
          </VisibleContent>
          <VisibleContent visible={!isLoading && !errorMessage && exhibitions.length === 0}>
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography color="textSecondary">
                {hasFilters
                  ? "Нет данных, соответствующих фильтрам"
                  : "Нет данных о выставлениях для этого комплекса"}
              </Typography>
            </Box>
          </VisibleContent>
          <VisibleContent visible={!isLoading && !errorMessage && exhibitions.length > 0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Дата</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Время начала</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Время окончания</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Местоположение</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Госномер оператора</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {exhibitions.map((exhibition, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{this.formatDate(exhibition.file_date)}</TableCell>
                    <TableCell>{exhibition.start_time || 'Н/Д'}</TableCell>
                    <TableCell>{exhibition.end_time || 'Н/Д'}</TableCell>
                    <TableCell>{exhibition.location || 'Н/Д'}</TableCell>
                    <TableCell>{exhibition.grz_ts || 'Н/Д'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <VisibleContent visible={totalPages > 1}>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="textSecondary">
                  Показано {startIndex}-{endIndex} из {totalCount} записей
                </Typography>
                <Pagination
                  count={totalPages}
                  page={filter.page}
                  onChange={this.handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                />
              </Box>
            </VisibleContent>
          </VisibleContent>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Button
                size="small"
                color="secondary"
                variant="contained"
                onClick={this.close}
              >Закрыть</Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DialogExhibitions

